<template>
  <div class="Onlinelass"  v-loading="!loaded">
    <div style="min-height:70vh">
      <div>
        <el-carousel class="carousel-box" height="516px" v-if="bannerList.length>0">
          <el-carousel-item v-for="(item, index) in bannerList" :key="index">
            <div class="carousel-img" :style="{'background-image': `url(${item.image_url})`}"></div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="tag">
        <div class="container">
          <div class="overf-h clearfix">
            <span class="lable wid">分类：</span>
            <div>
              <span
                @click="category_id='';getCourseList()"
                :class="['wid','cont',category_id==''?'active':'']"
              >全部</span>
              <span
                v-for="(items, index1) in categories"
                :class="['wid','cont',items.id==category_id?'active':'']"
                :key="index1"
                @click="category_id=category_id==items.id?'':items.id;getCourseList()"
              >{{items.name}}</span>
            </div>
          </div>
          <div class="overf-h clearfix">
            <span class="lable wid">岗位：</span>
            <div>
              <span
                @click="duty_id='';getCourseList()"
                :class="['wid','cont',duty_id==''?'active':'']"
              >全部</span>
              <span
                v-for="(items, index1) in duty_idArr"
                :class="['wid','cont',items.id==duty_id?'active':'']"
                :key="index1"
                @click="duty_id=duty_id==items.id?'':items.id;getCourseList()"
              >{{items.name}}</span>
            </div>
          </div>
          <div class="overf-h clearfix">
            <span class="lable wid">排序：</span>
            <div>
              <span
                @click="order_by='';getCourseList()"
                :class="['wid','cont',order_by==''?'active':'']"
              >全部</span>
              <span
                v-for="(items, index1) in order_byArr"
                :class="['wid','cont',items.value==order_by?'active':'']"
                :key="index1"
                @click="order_by=order_by==items.value?'':items.value;getCourseList()"
              >{{items.name}}</span>
            </div>
          </div>
        </div>
      </div>
      <ul class="sort container overf-h">
        <li
          v-for="(item,index) in courseList"
          :key="index"
          @click="$router.push({path:'classDetail',query:{id:item.id}})"
        >
          <div class="sort-img">
            <el-image :src="item.thumb_image" lazy class="class-img"></el-image>
          </div>
          <div class="sort-des">{{item.title}}</div>
          <div class="sort-rate overf-h">
            <div class="price-box overf-h">
              <el-rate
                :value="item.score-0"
                disabled
                :colors="colors"
                show-score
                text-color="#505050"
              ></el-rate>
              <div class="sort-price">¥{{item.price}}</div>
            </div>
            <!-- <div class="class-box">班级课程</div> -->
          </div>
        </li>
      </ul>
      <Empty v-if="loaded&&courseList.length==0"   />
    </div>
    <div class="container" v-if="courseList.length>0">
      <div style="margin:20px 0 40px;text-align: center;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 50, 100, 200]"
          :page-size="limit"
          layout=" sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Empty from "@/components/Empty";
export default {
  name: "OnlineClass",
  components: { Empty },
  data: function () {
    return {
      total: 0,
      limit: 10,
      page: 1,
      colors: ["#33B17B", "#33B17B", "#33B17B"],
      order_by: "",
      category_id: "",
      order_byArr: [
        { name: "销量", value: "sell_num" },
        { name: "上架时间", value: "up_at" },
        { name: "评分", value: "score" },
      ],
      duty_id: "",
      duty_idArr: [],
      bannerList: [], //轮播图
      categories: [],
      searchForm: {
        keyword: "",
      },
      value: "3.8",
      active1: 0,
      active2: 0,
      active3: 0,
      courseList: [],
      loaded:false,
      tag: [],
      sort: ["销量", "评分", "上架时间"],
    };
  },

  created() {
    if (this.$route.query) {
      if (this.$route.query.pid) {
        this.category_id = this.$route.query.pid;
      }
      if (this.$route.query.order_by) {
        this.order_by = this.$route.query.order_by;
      }
    }

    this.getcategory("");
    this.getBanner();
    this.getCourseList();
    this.getPosition();
  },

  methods: {
    // 轮播图
    getBanner() {
      this.$http({
        url: "api/v1/banners",
        method: "get",
        params: { type: "5" },
      }).then((res) => {
        if (res.status == 200) {
          this.bannerList = res.data.banners;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 分类
    getcategory(id, cb) {
      this.$http({
        url: "api/v1/categories?parent_id=" + id,
        method: "get",
      }).then((res) => {
        if (res.status == 200) {
          if (id && cb) {
            cb(res.data.categories);
          } else {
            this.categories = res.data.categories;
            // this.categories.forEach(element => {
            //   this.getcategory(element.id, list => {
            //     this.$set(element, "list", list);
            //   });
            // });
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getPosition() {
      this.$http({
        url: "api/v1/duties/all",
        method: "get",
      }).then((res) => {
        if (res.status == 200) {
          this.duty_idArr = res.data.duties;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    /**选择分类 */
    choosetype(index, type) {
      if (type == 1) {
        this.active1 = index;
      } else if (type == 2) {
        this.active2 = index;
      } else if (type == 3) {
        this.active3 = index;
      }
    },
    /** 获取列表*/
    getCourseList() {
      this.$http({
        url: "api/v1/auth/courses",
        method: "get",
        params: {
          keyword: this.keyword,
          page: this.page,
          limit: this.limit,
          order_by: this.order_by,
          duty_id: this.duty_id,
          category_id: this.category_id,
        },
      }).then((res) => {
        if (res.status == 200) {
           this.loaded=true;
          this.courseList = res.data.courses;
          if (res.data.total) {
            this.total = res.data.total;
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    /**每页数 */
    handleSizeChange(val) {
      this.limit = val;
      this.page = 1;
      this.getCourseList();
    },
    /**当前页 */
    handleCurrentChange(val) {
      this.page = val;
      this.getCourseList();
    },
  },
};
</script>

<style lang="less" scoped>
.clearfix {
  clear: both;
}
.carousel {
  height: 450px;
  position: relative;
  .carousel-box,
  /deep/ .el-carousel__container {
    height: 100%;
  }
}
.carousel-img {
  height: 100%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.lable {
  float: left;
  color: rgba(0, 0, 0, 0.56);
  font-size: 14px;
  margin-right: 0;
  width: 60px;
}
.all {
  float: left;
  margin-right: 10px;
  color: rgba(0, 0, 0, 0.56);
  font-size: 14px;
}
.wid {
  line-height: 36px;
  height: 36px;
  cursor: pointer;
  padding: 0 5px;
}
.type-box {
  margin-bottom: 20px;
  overflow: hidden;
}
.cont {
  color: rgba(0, 0, 0, 0.56);
  margin-bottom: 10px;
  display: block;
  padding: 0 10px;
  float: left;
  font-size: 14px;
  line-height: 36px;
  text-align: center;
  margin-right: 10px;
  border-radius: 10px;
}
.tag {
  margin-top: 77px;
  margin-bottom: 32px;
}
.sort {
  overflow: hidden;
  padding: 30px 0;
}
.Onlinelass {
  .sort li {
    width: 216px;
    padding-bottom: 26px;
    float: left;
    margin-right: 18px;
    .sort-img {
      width: 216px;
      height: 120px;
      border-radius: 10px;
      overflow: hidden;
      .class-img {
        width: 216px;
        height: 120px;
        border-radius: 10px;
        transition: all 0.6s;
      }
      .class-img:hover {
        cursor: pointer;
        transform: scale(1.1);
      }
    }
    .price-box {
      float: left;
    }
    .class-box {
      float: right;
    }
    .sort-des {
      cursor: pointer;
      margin-top: 10px;
      margin-bottom: 9px;
      color: rgba(7, 17, 27, 1);
      font-size: 16px;
      height: 48px;
      line-height: 24px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .class-box {
      margin-top: 10px;
      width: 56px;
      height: 20px;
      text-align: center;
      color: rgba(42, 130, 228, 1);
      background-color: rgba(42, 130, 228, 0.2857142857142857);
      border-radius: 2px;
      font-size: 11px;
    }
  }
}
.active {
  color: rgba(242, 13, 13, 0.7);
  background-color: rgba(242, 13, 13, 0.06);
}
</style>
